import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { distinctUntilChanged, map, withLatestFrom } from 'rxjs/operators';
import { AccountService } from '../services/account.service';
import { Store } from "@ngrx/store";
import { getCurrentOrganisation } from "../../views/user-management/redux/selectors";
import { filter } from "rxjs";

@Directive({
  selector: '[HasAuthority]',
  standalone: true
})
export class HasAuthorityDirective implements OnInit {
  private authorities: string[] = null;
  private features: string[] = null;

  constructor(private accountService: AccountService,
              private templateRef: TemplateRef<any>,
              private store: Store,
              private viewContainerRef: ViewContainerRef) {
  }

  @Input()
  set HasAuthority(value: string | string[]) {
    this.authorities = typeof value === 'string' ? [value] : value;
  }

  @Input()
  set HasAuthorityFeature(value: string | string[]) {
    this.features = typeof value === 'string' ? [value] : value;
  }

  ngOnInit(): void {
    this.accountService.hasAnyAuthority(this.authorities).pipe(
      withLatestFrom(this.store.select(getCurrentOrganisation).pipe(
          filter(org => !!org),
          map((organisation) => {
            return this.features?.some((feature) => {
              return organisation[feature] === true;
            }) ?? false;
          })
        ),
      ),
      map(([hasRole, hasFeature]) => {
        if (!this.features?.length) {
          return hasRole;
        }
        if (!this.authorities?.length && this.features?.length) {
          return hasFeature;
        }
        if (this.features?.length && this.authorities?.length) {
          return hasRole || hasFeature;
        }
      }),
      distinctUntilChanged()
    ).subscribe((hasAccess) => {
      if (hasAccess) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainerRef.clear();
      }
    });
  }
}
